<div class="relative flex h-full flex-col overflow-y-auto py-5">
  <pl-icon
    [frame]="IconFrame.round"
    [name]="PlIcon.close"
    (click)="closeModal()"
    class="absolute right-2 top-2 z-10 h-12 w-12 cursor-pointer border-transparent bg-transparent text-pl-gray-700 hover:bg-pl-gray-200"
  />
  <div class="flex grow flex-col gap-4 overflow-auto px-5">
    <h2 class="text-center font-sans text-lg uppercase text-pl-gray-500">
      {{ 'blocks.lifeAct.add_to_calendar' | translate }}
    </h2>
    <pl-input [(ngModel)]="title" [label]="'blocks.lifeAct.title' | translate" [showRightIcon]="false" />
    <ng-container *ngIf="description">
      <h5 class="text-lg font-bold text-pl-gray-700">
        {{ 'blocks.lifeAct.description' | translate }}
      </h5>
      <p class="whitespace-normal break-words font-sans text-pl-gray-450">{{ description | plSlice }}</p>
    </ng-container>
    <h5 class="text-lg font-bold text-pl-gray-700">
      {{ 'blocks.lifeAct.when' | translate }}
    </h5>

    <div class="flex w-full gap-4">
      <pl-datepicker class="grow" [(ngModel)]="dateSelected" />
      <pl-timepicker class="grow" [minutesGap]="timepickerGap" [(ngModel)]="timeSelected" [format]="timeFormat()" />
    </div>

    <h5 class="text-lg font-bold text-pl-gray-700">
      {{ 'blocks.lifeAct.select_calendar' | translate }}
    </h5>
    <div class="flex items-center justify-center gap-4">
      <div *ngFor="let icon of calendarIcons" class="h-20 w-20 cursor-pointer rounded-md p-2 hover:bg-pl-gray-200">
        <pl-icon [name]="icon" (click)="addEventToCalendar(icon)" />
      </div>
    </div>
  </div>
</div>
